import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod/v4-mini"
import {size2Like, vector2Like} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"
import {imageOpHalOptions} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-types"

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            imageOpHalOptions: imageOpHalOptions,

            sourceImage: anyImageOpResult,
            shape: z.union([
                z.object({
                    numPatches: z.optional(vector2Like), // default: computed from image size and patch size
                    patchSize: size2Like,
                }),
                z.object({
                    numPatches: vector2Like,
                    patchSize: z.optional(size2Like), // default: computed from image size and number of patches
                }),
            ]),
            options: z.optional(
                z.object({
                    allowPatchFill: z.optional(z.boolean()), // default: false; allow for size to be not a multiple of patch size, filling the remaining pixels with the address mode provided
                }),
            ),
        }),
    },
}
